import React from 'react';
import MyGallery from "../Gallery/MyGallery";
import './ServicesPage.css';
import {useTranslation} from "react-i18next";

function FloorPage() {
    const { t } = useTranslation();
    const directory= "/images/patoma/";
    const filenames=[
        'VPR02551_Vasso_Paraschi.webp',
        'VPR02825_Vasso_Paraschi.webp',
        'VPR02837-Enhanced-NR_Vasso_Paraschi.webp',
        'VPR02883_Vasso_Paraschi.webp',
        'VPR02887_Vasso_Paraschi.webp',
        'VPR02981_Vasso_Paraschi.webp',
        'VPR03000_Vasso_Paraschi.webp',
        'VPR03002_Vasso_Paraschi.webp',
        'VPR03017_Vasso_Paraschi.webp',
        'VPR03117_Vasso_Paraschi.webp',
        'VPR03128-Enhanced-NR_Vasso_Paraschi.webp'
    ];

    return (
        <div className="services-page">
            <h1>{t("Flooring")}</h1>
            <div className="services-info-container">
                <MyGallery directory={directory} filenames={filenames} />
            </div>

        </div>
    );
}

export default FloorPage;
